import React, { useEffect, useState } from "react"
import withStyles from "react-jss"
import smoothscroll from "smoothscroll-polyfill"
import "./Ticker.css"
import { useCountUp } from "react-countup"
import { tickerarrow } from "../../assets/images"
import { autoType } from "d3"

smoothscroll.polyfill()

const styles = {
  sticky: {
    boxSizing: "border-box",
    position: "sticky",
    bottom: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  invisibleTrigger: {
    width: "100%",
    height: "40px",
    background: "transparent",
    pointerEvents: "none",
    margin: "100vh 0 -100vh 0",
  },
  arrow: {
    position: "absolute",
    top: "95vh",
    left: "50%",
    transform: "translateX(-50%)",
  },
}

const Ticker = ({ classes }) => {
  const [startVal, setStartVal] = useState(0)
  const [endVal, setEndVal] = useState(0)
  const [hideTicker, setHideTicker] = useState(false)
  useEffect(() => {
    const items = Array.from(
      document.querySelectorAll("#textContentTicker .leftBoxTicker")
    )

    const imgs = document.querySelectorAll(
      "#contentScoreTicker .rightBoxTicker .rightBoxTickerContent .rightBoxTickerContentPara"
    )

    const counterValues = [9409, 19103, 23111, 24190, 26989, 29110]

    const detectIntersection = (entries) => {
      for (let e of entries) {
        let j = items.indexOf(e.target)

        if (e.isIntersecting) {
          for (let i = 0; i < items.length; i++) {
            items[i].classList.remove("visibleTicker")
          }
          for (let i = 0; i < imgs.length; i++) {
            if (e.target.querySelector("div").classList.contains("redTick")) {
              if (imgs[i].classList.contains("changeToRed")) {
                imgs[i].classList.add("redColor")
              }
            } else {
              imgs[i].classList.remove("redColor")
            }
          }
          e.target.classList.add("visibleTicker")
          if (j !== 0) imgs[j - 1].classList.remove("visibleTicker")

          imgs[j] && imgs[j].classList.add("visibleTicker")

          if (j !== 0) {
            setStartVal(counterValues[j - 1])
            setEndVal(counterValues[j])
          }
        } else {
          if (e.boundingClientRect.top < 600) {
            for (let i = 0; i < items.length; i++) {
              items[i].classList.add("visibleTicker")
            }

            for (let i = 0; i < imgs.length; i++) {
              if (e.target.querySelector("div").classList.contains("redTick")) {
                if (imgs[i].classList.contains("changeToRed")) {
                  imgs[i].classList.add("redColor")
                }
              } else {
                imgs[i].classList.remove("redColor")
              }
            }
            e.target.classList.add("visibleTicker")
            //if (j !== 0) imgs[j].classList.add("visibleTicker");

            imgs[j + 1] && imgs[j + 1].classList.add("visibleTicker")

            if (j !== 0 || j !== 1) {
              setStartVal(counterValues[j - 2])
              setEndVal(counterValues[j - 1])
            }
            if (j == 1) {
              setStartVal(counterValues[j])
              setEndVal(counterValues[j - 1])
            }
          } else {
            e.target.classList.remove("visibleTicker")
            imgs[j] && imgs[j].classList.remove("visibleTicker")
          }
        }
      }
    }

    const options = {
      threshold: 1,
    }

    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => observer.observe(i))
  }, [])

  useEffect(() => {
    const items = [document.querySelector("#stickyTicker-trigger")]

    const detectIntersection = (entries) => {
      for (let e of entries) {
        if (e.boundingClientRect.top < 0) {
          if (e.isIntersecting) {
            //scroll up
            setHideTicker(false)
          } else {
            //scroll down
            setHideTicker(true)
          }
        }
      }
    }
    const options = {
      threshold: 0,
    }
    const observer = new IntersectionObserver(detectIntersection, options)
    items.forEach((i) => observer.observe(i))
  })
  // useEffect(() => {
  //   const items = [document.querySelector("#Ticker")];

  //   const detectIntersection = (entries) => {
  //     for (let e of entries) {
  //       if (e.isIntersecting) {
  //         //setHideTicker(false);
  //         document.body.style.overflow = "hidden";
  //       } else {
  //         //setHideTicker(true);
  //       }
  //     }
  //   };
  //   const options = {
  //     threshold: 1,
  //   };
  //   const observer = new IntersectionObserver(detectIntersection, options);
  //   items.forEach((i) => observer.observe(i));
  // });
  useCountUp({
    ref: "0",
    start: 9409,
    end: 9409,
    duration: 0.5,
    separator: ",",
  })
  useCountUp({
    ref: "1",
    start: startVal,
    end: endVal,
    duration: 0.5,
    separator: ",",
  })

  useCountUp({
    ref: "2",
    start: startVal,
    end: endVal,
    duration: 0.5,
    separator: ",",
  })

  useCountUp({
    ref: "3",
    start: startVal,
    end: endVal,
    duration: 0.5,
    separator: ",",
  })

  useCountUp({
    ref: "4",
    start: startVal,
    end: endVal,
    duration: 0.5,
    separator: ",",
  })

  useCountUp({
    ref: "5",
    start: startVal,
    end: endVal,
    duration: 0.5,
    separator: ",",
  })

  return (
    <section
      id="Ticker"
      style={{ visibility: hideTicker ? "hidden" : "visible" }}>
      <section id="textContentTicker">
        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent hiddenScroll"></div>
        </div>

        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent">
            <p>BEING YOUNG</p>
          </div>
        </div>
        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent">
            <p>BEING A WOMAN</p>
          </div>
        </div>
        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent">
            <p>HAVING CHILDREN</p>
          </div>
        </div>
        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent redTick">
            <p>NOT KNOWING DUTCH</p>
          </div>
        </div>
        <div className="leftBoxTicker">
          <div className="leftBoxTickerContent redTick">
            <p>STRUGGLING TO PAY BILLS</p>
          </div>
        </div>
      </section>
      <div className={classes.sticky}>
        <div className="rating"> RISK RANKING</div>
        <section id="contentScoreTicker">
          <div className="rightBoxTicker">
            <div className="rightBoxTickerContent tickerBox">
              <div className="rightBoxTickerContentPara">
                <span id="0" />
              </div>
              <div className="rightBoxTickerContentPara">
                <span id="1" />
              </div>
              <div className="rightBoxTickerContentPara">
                <span id="2" />
              </div>
              <div className="rightBoxTickerContentPara">
                <span id="3" />
              </div>
              <div className="rightBoxTickerContentPara changeToRed">
                <span id="4" />
              </div>
              <div className="rightBoxTickerContentPara changeToRed">
                <span id="5" />
              </div>
            </div>
          </div>
        </section>{" "}
      </div>
      <div id="arrowMark" className={classes.arrow}>
        <img src={tickerarrow}></img>
      </div>
    </section>
  )
}

export default withStyles(styles)(Ticker)
